import React from 'react'
import ReactHighSock from  'react-highcharts/ReactHighstock'
import '../../../index.css'
import ReactHighcharts from  'react-highcharts'

ReactHighcharts.Highcharts.setOptions({
    global: {
        useUTC: false
    }
});

const initializeChart = (xAxis, noise) => {
    let data = [];
    if (noise.length < 30) {
        let i = 0;
        while (i < noise.length) {
            data.push({
                x: xAxis[i],
                y: noise[i]
            });
            i += 1
        }
    } else {
        let i = noise.length - 30;
        while (i < noise.length) {
            data.push({
                x: xAxis[i],
                y: noise[i]
            });
            i += 1
        }
    }
    return data;

};

export const NoiseChart = props => {
    const config = {
        tooltip: {
            valueDecimals: 2,
        },
        xAxis: {
            categories: props.xAxis,
            type: 'datetime',
            labels: {
                format: '{value:%H:%M:%S}',
                rotation: 0,
                style: {
                    color: '#f2f2f2'
                }

            },
        },
        yAxis: {
            title: {
                enabled: false
            },
            min: 0,
            max: 100,
            labels: {
                style: {
                    color: '#f2f2f2'
                }
            }
        },
        series: [{
            name: "Noise",
            type: 'spline',
            data: initializeChart(props.xAxis, props.messages)
        }],
        title: {
            floating: true,
            text: ""
        },
        chart: {
            height: 200,
            spacingBottom: 5,
            spacingTop: 10,
            spacingLeft: 5,
            spacingRight: 5,
            backgroundColor: " rgba(255, 255, 255, 0.0)"
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        navigator: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        },
        rangeSelector: {
            enabled: false
        },


    };

    return (
        <ReactHighSock config={config} ref="chart"/>
    )
};

    // shouldComponentUpdate(nextProps) {
    //     if (this.props.messages == nextProps.messages) return false
    //
    //     const time = nextProps.xAxis.filter(x => this.props.xAxis.indexOf(x) == -1)[0]
    //     const value = nextProps.messages.filter(x => this.props.messages.indexOf(x) == -1)[0]
    //
    //     let chart = this.refs.chart.getChart()
    //     if (chart.series[0].data.length > 30) {
    //         chart.series[0].addPoint([
    //             time,
    //             value], true, true, false
    //         )
    //     } else {
    //         chart.series[0].addPoint([
    //             time,
    //             value
    //         ])
    //     }
    //
    //     return false
    // }


// WEBPACK FOOTER //
// ./src/components/Map/Common/NoiseChart.js